exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-form .el-form-item[data-v-087124d4]{margin-bottom:0}", ""]);

// exports
